<template>
  <v-app  id="app" :class="[userTheme]">
    <router-view/>
    <v-overlay :value="loadingArray.length > 0" z-index="9999">
      <v-progress-circular
        indeterminate
        :color="userStyle.color"
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <GlobalDialog></GlobalDialog>
  </v-app>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { getToken } from '@/utils/auth';
import GlobalDialog from './components/dialog/GlobalDialog.vue';

export default {
  name: 'App',
  components: { GlobalDialog },
  data: () => ({
  }),
  created() {
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('userInfo', ['GET_USER_PROFILE', 'GET_USER_MODULES']),
    async init() {
      const token = getToken();
      if (token) {
        // await this.GET_USER_PROFILE();
        // await this.GET_USER_MODULES();
      }
    },
  },
  computed: {
    ...mapState('config', ['loadingArray']),
    ...mapState('userInfo', ['userInfo']),
    ...mapGetters('userInfo', ['userStyle']),
    userTheme() {
      let theme = '';
      if (this.userInfo.userStyle) {
        theme = this.userInfo.userStyle;
      }
      return theme;
    },
  },
};
</script>
<style lang="scss">
//
</style>
